import React, { Component } from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import './Footer.css';
import SocialList from '../SocialList';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import requestAll from '../../actions/Common';
import { bindActionCreators } from 'redux';
import { loadInformation } from '../../actions/InformationActions';
import { loadFooterLinks } from '../../actions/FooterActions';
import { loadSocial } from '../../actions/SocialActions';
import scrollFunction from '../../utils/scroll';

const phoneRegEx = /[\s()-]/g;
const isUrlAbsolute = new RegExp('^(?:[a-z]+:)?//', 'i');

const FooterLink = props => (
  isUrlAbsolute.test(props.link.url) ?
  <a target="_blank" href={props.link.url} className={`footer__link ${props.dark ? ' footer__link--dark' : ''}`} rel="noopener noreferrer">{props.link.name}</a>
  :
  <Link scroll={scrollFunction} to={props.link.url} className={`footer__link ${props.dark ? ' footer__link--dark' : ''}`}>{props.link.name}</Link>
);

class Footer extends Component {
  static requestData(store) {
    return requestAll([loadInformation, loadFooterLinks, loadSocial], store);
  }
  componentDidMount() {
    this.props.actions.loadInformation();
    this.props.actions.loadFooterLinks();
    this.props.actions.loadSocial();
  }

  render() {
    // преобразуем все соцсети в массив
    let socialList = [];
    if (this.props.social) {
      for (let social in this.props.social) {
        const link = this.props.social[social]
        socialList.push({social, link})
      }
    }

    // форматирование номера телефона
    let phone = this.props.baseCity.baseCityPhone ? this.props.baseCity.baseCityPhone : this.props.information.phone;
    let parsPhone = "";
    if (phone) {
      parsPhone = phone.replace(phoneRegEx, "")
    }

    // фильтруем ссылки в меню по позиции
    const leftTopLinks = this.props.footer.filter((links) => {
      return links.position === "left_top";
    });
    const leftBottomLinks = this.props.footer.filter((links) => {
      return links.position === "left_bottom";
    });
    const leftCenterLinks = this.props.footer.filter((links) => {
      return links.position === "center";
    });
    const leftRightLinks = this.props.footer.filter((links) => {
      return links.position === "right";
    });

    return (
      <footer className="footer container container--full">
        <div className="row footer__row">
          <div className="col col--4 colVertTablet--12 footer__marginVertTablet">
            <div className="row">
              <div className="col col--12 colVertTablet--6">
                {
                  leftTopLinks.map((link, index) => (
                    <FooterLink key={`footer__link-${index}`} dark={false} link={link} />
                  ))
                }
              </div>
              <div className="col col--12 colVertTablet--6">
                {
                  leftBottomLinks.map((link, index) => (
                    <FooterLink key={`footer__link-${index}`} dark={false} link={link} />
                  ))
                }
              </div>
            </div>
          </div>
          <div className="col col--4 colVertTablet--12">
            {
              leftCenterLinks.map((link, index) => (
                <FooterLink key={`footer__link-${index}`} link={link} />
              ))
            }
          </div>
          <div className="col col--4 colVertTablet--12">
           {
              leftRightLinks.map((link, index) => (
                <FooterLink key={`footer__link-${index}`} link={link} />
              ))
            }
          </div>
        </div>
        <div className="row">
          <div className="col col--4 colVertTablet--12 colOrderVertTablet--3">
            <div className="footer__helptext">© АО «ЭР-Телеком Холдинг»</div>
            <div className="footer__helptext">recruitment@ertelecom.ru</div>
          </div>
          <div className="col col--4 colVertTablet--12 colOrderVertTablet--2 footer__marginVertTablet">
            <SocialList socials={socialList} />
          </div>
          <div className="col col--4 colVertTablet--12 footer__phone">
            {
            (this.props.baseCity.baseCityPhone || this.props.information.phone) &&
            <div className="footer__helptext">Связаться по телефону:</div>
            }
            {
              (this.props.baseCity.baseCityPhone || this.props.information.phone) &&
              <a href={`tel:${parsPhone}`} className="footer__link footer__link--noUnderline">{phone}</a>
            }
          </div>
        </div>
      </footer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    information: state.information.item,
    footer: state.footer.list,
    social: state.social.item,
    baseCity: state.baseCity,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({ loadInformation, loadFooterLinks, loadSocial}, dispatch),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Footer));


// WEBPACK FOOTER //
// ./src/components/Footer/index.js